module.exports = __webpack_public_path__ + "static/media/carousel-new.d243be00.jpg";